export class VoiceClientDropMemberParticipantDto {
  constructor(private call_sid: string, private userId: string) {}
  body(): Object {
    return {
      call_sid: this.call_sid,
      name: `agent-${this.userId}`,
    };
  }
}
